import React from "react";
import {
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBCardHeader,
  MDBCardFooter,
} from "mdb-react-ui-kit";

const cardGradient = "linear-gradient(135deg, #e6f0f6 0%, #b7d3e6 100%)";
const headerBg = "rgba(118,164,187,0.7)";
const headerColor = "#234";

function formatDate(timestamp) {
  if (!timestamp) return "";
  const dateObj = new Date(timestamp);
  if (isNaN(dateObj.getTime())) return "";
  return dateObj.toLocaleDateString() + " " + dateObj.toLocaleTimeString();
}

function MessageCard(props) {
  const { name, country, city, message, date } = props;
  return (
    <MDBCard
      alignment="center"
      style={{
        background: cardGradient,
        color: "#234",
        borderRadius: "16px",
        boxShadow: "0 8px 32px 0 rgba(23,90,115,0.20)", // Stronger shadow on the whole card
        minWidth: 220,
        maxWidth: 350,
        margin: "0 auto",
      }}
    >
      <MDBCardHeader
        style={{
          background: headerBg,
          color: headerColor,
          fontWeight: "bold",
          fontSize: "1.05rem",
          borderTopLeftRadius: "16px",
          borderTopRightRadius: "16px",
          borderBottom: "none",
          letterSpacing: "0.5px",
        }}
      >
        {city ? `${city}, ${country}` : country}
      </MDBCardHeader>
      <MDBCardBody
        style={{
          background: "#fff",
        }}
      >
        <MDBCardTitle
          style={{ color: "#234", fontWeight: "bold", fontSize: "1.15rem" }}
        >
          {message}
        </MDBCardTitle>
        <MDBCardText style={{ color: "#345", whiteSpace: "pre-line" }}>
          {name}
        </MDBCardText>
      </MDBCardBody>
      {date && (
        <MDBCardFooter
          className="text-muted"
          style={{
            background: "rgba(255,255,255,0.25)",
            color: "#567",
            fontSize: "0.85rem",
            borderBottomLeftRadius: "16px",
            borderBottomRightRadius: "16px",
            borderTop: "none",
          }}
        >
          {formatDate(date)}
        </MDBCardFooter>
      )}
    </MDBCard>
  );
}

export default MessageCard;
